import * as React from 'react';

import cn from 'classnames';

import { Card } from '@components/common';
import { Tiptap, useTiptap } from '@components/shared/Tiptap';
import { noop } from '@components/utils';
import { Provider } from '@stores/account';

export const PublicDocument: React.FC<React.PropsWithChildren<{ insight: PublicInsight; studyId?: number | null }>> = ({
  insight,
  studyId
}) => {
  const tiptap = useTiptap({
    data: insight.document,
    apiEndpoint: 'public',
    readonly: true,
    studyId,
    config: {
      columns: true,
      image: { enable: true },
      link: { enable: true },
      artifacts: true,
      templates: true,
      placeholder: '',
      tables: true
    }
  });

  return (
    <Provider
      value={
        {
          account: {
            id: insight.account_id,
            team: []
          }
        } as any
      }
    >
      <Tiptap {...tiptap.getTiptapProps()}>
        <>
          <section className='px-page py-gutter relative h-full bg-gray-50'>
            <Card className='mx-auto w-full max-w-7xl rounded-lg'>
              <div
                style={insight.cover_image_url ? { paddingBottom: '29.75%' } : {}}
                className='relative mb-4 h-32 w-full'
              >
                {insight.cover_image_url && (
                  <img
                    alt='Cover'
                    className='absolute h-full w-full rounded-md object-cover'
                    src={insight.cover_image_url}
                  />
                )}
                <div
                  className={cn(
                    'tablet:space-y-0 tablet:flex-row tablet:items-end tablet:justify-end absolute flex h-full w-full flex-col items-center justify-end space-y-2 rounded-md p-2',
                    { 'bg-gray-200': !insight.cover_image_url }
                  )}
                ></div>
              </div>
              <tiptap.Content {...tiptap.getContentProps()} />
            </Card>
          </section>
        </>
      </Tiptap>
    </Provider>
  );
};
